import { useEffect, useState } from "react";

// 0018: anti-flicker gate for skeletons. Returns true only once `active` has stayed true
// for at least `delayMs`. Fast/cached loads (e.g. 0016's 5-min staleTime lists) resolve
// before the delay elapses, so the skeleton never renders and there is no flash. As soon as
// `active` goes false the flag resets immediately (no lingering skeleton).
const useDelayedFlag = (active, delayMs = 120) => {
  const [delayed, setDelayed] = useState(false);

  useEffect(() => {
    if (!active) {
      setDelayed(false);
      return undefined;
    }
    const timer = setTimeout(() => setDelayed(true), delayMs);
    return () => clearTimeout(timer);
  }, [active, delayMs]);

  return delayed;
};

export default useDelayedFlag;
